module.exports = __webpack_public_path__ + "img/yhzc_diannao.c8ae38e9.png";